import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const LoggedOut = ({ onMount }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const expired = params.get("reason") === "expired";

  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, [onMount]);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>
        {expired ? "Session expired" : "You have been logged out successfully"}
      </h2>
      <p>
        {expired
          ? "Your session has expired. Please click the button below to login again."
          : "Thank you for using our application."}
      </p>
      <a href="/login" style={{ color: "#007bff", textDecoration: "none" }}>
        Click here to login again
      </a>
    </div>
  );
};

export default LoggedOut;
